import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import WarningIcon from '@material-ui/icons/Warning';

const NoActivityContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const NoActivityIcon = styled(WarningIcon)`
  width: 50px;
  height: 50px;
  opacity: 0.3;
`;

const NoActivityMessage = styled.span`
  font-size: 16px;
  opacity: 0.4;
`;

const NoActivityIndicator: FC = () => {
  const { t } = useTranslation();
  return (
    <NoActivityContainer>
      <NoActivityIcon />
      <NoActivityMessage>
        {t('activity_log.no_activity_message', 'No Activity Found')}
      </NoActivityMessage>
    </NoActivityContainer>
  );
};

export default NoActivityIndicator;
